export default __webpack_public_path__ + "static/media/img-proj-siam-blockchain-pro.f9529b36.png";